import type { Database } from '../types';

type Tables = Database['public']['Tables'];

// Таблицы, которые живут в снимке и приходят событиями журнала.
export const TABLE_NAMES = [
  'person', 'profile', 'team', 'team_member',
  'timeline_lane', 'project', 'subproject', 'task', 'task_assignee',
  'event', 'event_project', 'vacation', 'question', 'answer', 'shared_setting', 'lane_project', 'event_series',
  'launch', 'launch_swimlane', 'launch_track', 'launch_task', 'launch_link',
] as const;
export type TableName = (typeof TABLE_NAMES)[number];

export type Row<T extends TableName> = Tables[T]['Row'];
export type AnyRow = { id: string; updated_at?: string } & Record<string, unknown>;

export type TableMaps = { [K in TableName]: Map<string, Row<K>> };

export function emptyTables(): TableMaps {
  const t = {} as TableMaps;
  for (const n of TABLE_NAMES) (t as Record<string, Map<string, unknown>>)[n] = new Map();
  return t;
}

export type ChangeEvent = {
  id: number;
  tx: string;
  actor: string | null;
  op: Record<string, unknown> | null;
  table_name: string;
  row_id: string;
  kind: 'insert' | 'update' | 'delete';
  changed: string[];
  old: Record<string, unknown> | null;
  new: Record<string, unknown> | null;
  at: string;
};

export type Snapshot = { log_id: number; from_date: string } & { [K in TableName]: Row<K>[] };

// Одно изменение для apply_changes. `set` — по id; `insert` — строка; `delete` — по id.
export type Change =
  | { table: TableName; id: string; set: Record<string, unknown>; expect_updated_at?: string }
  | { table: TableName; insert: Record<string, unknown> }
  | { table: TableName; id: string; delete: true };

export type Op = { kind: string } & Record<string, unknown>;

export type Connection = 'connecting' | 'online' | 'reconnecting' | 'paused' | 'offline';

export const isTableName = (s: string): s is TableName => (TABLE_NAMES as readonly string[]).includes(s);
